import useChangelog from "../helpers/useChangelog";
import {useLocalStorage} from "usehooks-ts";
import {Operator} from "../helpers/Operator";
import {useEffect, useState} from "react";
import getTimetableInfo from "../apiCalls/getTimetableInfo";
import apiErrorHandler from "../helpers/apiErrorHandler";
import {Card, Col, Container, Placeholder, Row} from "react-bootstrap";

/**
 * Informacje o danych rozkładowych
 * @param {Operator} operator
 * @return {JSX.Element}
 * @constructor
 */
function OperatorInfo({operator}) {
    return <Card style={{height: "100%"}}>
        <Card.Body>
            {/* W sytuacji gdy danych o operatorze nie ma dajemy goły szablon zamiast danych */}
            {!operator && <>
                <Placeholder as={Card.Title} animation={"glow"}><Placeholder xs={6}/></Placeholder>
                <Placeholder as={Card.Text} animation={"glow"}>
                    Źródło danych: <Placeholder xs={6}/><br/>
                    Czas wytworzenia pliku GTFS: <Placeholder xs={6}/><br/>
                    Zakres danych rozkładowych <Placeholder xs={6}/><br/>
                </Placeholder>
            </>}
            {operator && <>
                <Card.Title>{operator.nazwa_spisTaboru}</Card.Title>
                <Card.Text>
                    {operator.timetable_source && <>Źródło danych: <b>{operator.timetable_source}</b><br/></>}
                    {operator.feed_version &&
                        <>Czas wytworzenia pliku GTFS: <b>{operator.feed_version.toLocaleString()}</b><br/></>}
                    {(operator.data_from && operator.data_to) &&
                        <>Zakres danych rozkładowych: <b>
                            {`${operator.data_from.toLocaleDateString()} – ${operator.data_to.toLocaleDateString()}`}</b></>}
                </Card.Text>
            </>}
        </Card.Body>
    </Card>
}

export default function About({navigate, setErrorBannerText}) {
    const [changelog,] = useChangelog();
    const actualVersion = useLocalStorage("lastVersion", "");
    const [operatorzy, setOperatorzy] = useState([]);

    useEffect(() => {
        getTimetableInfo()
            .then(resp => {
                const op = resp.map(x => {
                    const o = Operator.getByName(x.prefix_id);
                    o.updateTimetableInfo(x.timetable_source, x.data_from, x.data_to, x.feed_version);
                    return o;
                });
                setOperatorzy(op);
            })
            .catch(err => apiErrorHandler(err, navigate, setErrorBannerText));
    }, [navigate, setErrorBannerText, setOperatorzy])

    return (
        <div className={"mx-2"}>
            <div className={"h2 text-center mb-4"}>Informacje o projekcie</div>
            <div>
                <p>
                    KolMaz to niezależny projekt, który umożliwia uzyskanie informacji na temat taboru obsługującego
                    poszczególne połączenia Kolei Mazowieckich i&nbsp;Szybkiej Kolei Miejskiej w&nbsp;Warszawie.
                    Dane o taborze pochodzą z zestawień prezentowanych&nbsp;
                    <a href={"https://www.mazowieckie.com.pl/pl/kategoria/rozklady-jazdy"}>
                        na stronie Kolei Mazowieckich
                    </a>. Dane o&nbsp;taborze SKM pochodzą z&nbsp;rozkładu jazdy.
                </p>
                <p>
                    Aplikacja zawiera wyłącznie statyczny rozkład jazdy i nie dostarcza informacji o aktualnych
                    opóźnieniach w kursowaniu pociągów.
                    Zestawienia składów mają charakter orientacyjny i&nbsp;mogą ulegać zmianom.
                </p>
                <p>Autorem aplikacji jest Dominik Pych.</p>
                <h3 className={"h3"}>Źródła danych</h3>
                <div>
                    Rozkłady są generowane na podstawie plików GTFS autorstwa Mikołaja Kuranowskiego,
                    dostępnych na stronie&nbsp;
                    <a href={"https://mkuran.pl"}>mkuran.pl</a>.
                    <Container>
                        <Row md={2} sm={1} xs={1}>
                            {operatorzy.map(o => <Col key={o.short}>
                                <OperatorInfo operator={o}/>
                            </Col>)}
                            {operatorzy.length === 0 && <>
                                <Col><OperatorInfo operator={null}/></Col>
                                <Col><OperatorInfo operator={null}/></Col>
                            </>}
                        </Row>
                    </Container>
                </div>

                <h3 className={"h3 mt-2"}>Lista zmian</h3>
                <p>Aktualna wersja aplikacji: {actualVersion}</p>
                {
                    Object.keys(changelog).map(v => (
                        <div key={v}>
                            <h4>{v}</h4>
                            <ul>
                                {
                                    changelog[v].map((change, index) => (
                                        <li key={v + " " + index}>{change}</li>
                                    ))
                                }
                            </ul>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
